import safePerformanceMarkStart from 'mini-performance/lib/utils/safePerformanceMarkStart';
import TimeConstants from 'mini-datetime-utils/lib/dateValues/TimeConstants';
import { getApp } from 'owa-config/lib/bootstrapOptions';
import { getCriticalTimingData, trackCriticalBootTimingData } from './getCriticalTimingData';
import { getCustomPayloadForAppRenderBootAnalysis } from './getCustomPayloadForAppRenderBootAnalysis';
import { getOpxUpdateConfigDurationFromStart } from 'mini-deeplink-opx-bootstrap/lib/utils/updateConfigDurationFromStart';
import { logPerfMeasure } from 'bootstrap/lib/logPerfMeasure';
import { onSignal } from 'listeners/lib/signalTrackerListener';
import { safePerformanceMarkEnd } from 'mini-performance';
// import { getOwaWorkload } from 'owa-workloads';
import {
    setItemInSessionStorage,
    getItemFromSessionStorage,
} from 'mini-session-storage/lib/utils/sessionStorageUtils';

/**
 * Log the Largest Surface Render metric (time from navigation start to LCP event)
 */
export async function trackLargestSurfaceRender(
    signalsToTrack: string[],
    customPayloadToLog?: any,
    getCustomDataAccumulated?: () => any
) {
    trackCriticalBootTimingData();

    // If the document visibility state comes hidden here, assume that the page was hidden from the start.
    // This is the best assumption which can be made till the page visibility API improves to find past visibility changes with their timing
    const timeOfFirstPageHide =
        document.visibilityState === 'hidden' ? 0 : TimeConstants.MillisecondsInOneDay * 30;

    const listOfSignalPromises = signalsToTrack.map(onSignal);

    const data = await Promise.race(listOfSignalPromises);
    safePerformanceMarkStart('LargestSurfaceRender');
    safePerformanceMarkEnd('LargestSurfaceRender');
    const payload = await getCustomPayloadForAppRenderBootAnalysis(customPayloadToLog);

    const timingData = getCriticalTimingData();
    const accumulatedData = getCustomDataAccumulated?.();
    const moduleLoadData = getItemFromSessionStorage('moduleLoad') || [];
    if (moduleLoadData.length < 5) {
        moduleLoadData.push(getApp()[0]); // Log the first character of each app name to save some space in Kusto
    }
    setItemInSessionStorage('moduleLoad', moduleLoadData);
    const { beforePaintTime, afterPaintTime } = data?.customData;

    const flooredAfterPaintTime = Math.floor(afterPaintTime);

    // Need to log it for some time to identify reasons for higher render end.
    const perfTime = {
        cdiff: window.performance?.timing?.fetchStart - window.performance?.timing?.navigationStart,
        beforePaint: Math.floor(beforePaintTime),
    };

    logPerfMeasure(
        {
            duration: 0,
            startTime: flooredAfterPaintTime,
        } as PerformanceEntry,
        'LargestSurfaceRender',
        false /** logOnce */,
        true /** addToPageTimings */,
        true /** markAsCore */,
        {
            ...payload,
            ...timingData,
            ...perfTime,
            ...accumulatedData,
            ucdfs: getOpxUpdateConfigDurationFromStart() /* OPX UpdateConfig duration from start */,
            moduleLoad: JSON.stringify(moduleLoadData),
            wph: flooredAfterPaintTime > timeOfFirstPageHide /* was page hidden */,
            iph: false /* is page hidden */,
        }
    );
}
